module.exports = __webpack_public_path__ + "static/offer-envelope-front-70a8ce6ee225c0f51c0bc6e2ea0b4616.png";